import type { RecordKey } from 'types';

export const isObject = (value: unknown): value is Record<RecordKey, unknown> =>
    Boolean(value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date));

export default {};
